module.exports = __webpack_public_path__ + "static/img/04.79eec3c1.png";